import { Stack, SxProps } from '@mui/material';
import { LabelBox, ValueBox } from '@foxtaibox/foxtailbox-frontend-core';

interface IBlockProps {
  value: string;
  label: string;
  valueSx?: SxProps;
  labelSx?: SxProps;
}

const Block = ({ value, label, labelSx, valueSx }: IBlockProps) => {
  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 2 }}>
      <LabelBox text={label} sx={labelSx} />
      <ValueBox text={value} sx={{ width: '100%', flex: 1, ...valueSx }} />
    </Stack>
  );
};

export default Block;
